import type { MatDateFormats } from '@angular/material/core';
import { shortDateFormat } from '@shared/locale/locale';

const dateInput = shortDateFormat();

export const MAT_LUXON_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput,
    },
    display: {
        dateInput,
        monthYearLabel: 'LLL yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'LLL yyyy',
    },
};
